import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';
import c from 'classnames';

import { CookieWrapper } from '@uncinc/uncinc-react-kitchen-sink';
import {
  Button,
} from '..';

import AbbreviationAnnotation from '../AbbreviationAnnotation';

const DefaultWysiwygField = ({
  html,
  customElementHandler,
  ...props
}) => {

  let containsButton;
  const parsedHtml = ReactHtmlParser(html, {
    transform: (node) => {
      const customHandler = customElementHandler(node);

      if (customHandler) {
        return customHandler;
      }

      switch (node.name) {
        case 'p': {
          for (let index = 0; index < node.children.length; index++) {
            if (node.children[index].name === 'a') {
              if (node.children[index].attribs.class) {
                node.attribs.class = 'with-button';
              }
            }
          }
          break;
        }

        case 'iframe': {
          const { src, width, height, title } = node.attribs;
          return (
            <CookieWrapper>
              <iframe
                src={src}
                width={width || '100%'}
                height={height || '400'}
                title={title || 'Embedded content'}
                frameBorder="0"
                allowFullScreen
              />
            </CookieWrapper>
          );
        }

        case 'a': {
          if (node.attribs.class && node.attribs.class.indexOf('button--primary') !== -1) {
            containsButton = true;
            const label = node.children[0].data;
            return (
              <Button primary withIcon buttonIcon href={node.attribs.href} target={node.attribs.target || ''} rel={node.attribs.target ? 'noopener' : ''} key={`${node.name}:${label}`}>
                {label}
              </Button>
            );
          } else if (node.attribs.class && node.attribs.class.indexOf('button--download') !== -1) {
            containsButton = true;
            const label = node.children[0].data;
            return (
              <Button primary withIcon icon="download" className="Button--download" href={node.attribs.href} target={node.attribs.target || ''} rel={node.attribs.target ? 'noopener' : ''} key={`${node.name}:${label}`}>
                {label}
              </Button>
            );
          }
          break;
        }

        default: {
          break;
        }
      }
    },
  });


  const { className } = props;
  const WysiwygFieldClasses = c('WysiwygField', className, {
    'WysiwygField--has-button': containsButton,
  });

  return (
    <div {...props} className={WysiwygFieldClasses}>
      {parsedHtml}
    </div>
  );
};

DefaultWysiwygField.propTypes = {
  html: PropTypes.string.isRequired,
  customElementHandler: PropTypes.func,
};

DefaultWysiwygField.defaultProps = {
  customElementHandler: () => {},
};

const WysiwygField = ({
  ...props
}) => {
  return (
    <DefaultWysiwygField
      {...props}
      customElementHandler={(element) => {
        if (element.name === 'abbr') {
          return (<AbbreviationAnnotation title={element.attribs.title} {...element.attribs}>{ element.children[0].data }</AbbreviationAnnotation>);
        }
      }}
    />
  );
};

export default WysiwygField;
